import { createSlice } from "@reduxjs/toolkit";
import { fetchCapitalLedger ,fetchCapitalAccountsBySearch } from "../CapitalLedger/capitalLedgerThunk";

const initialState = {
  list: [],
  capitalAccounts: [],
  capitalAccountsLoading: false,
  filters: {
    account: null,
    dateFrom: null,
    dateTo: null,
  },
  loading: false,
  error: null,
};

const capitalLedgerSlice = createSlice({
  name: "capitalLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetCapitalLedger: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCapitalLedger.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCapitalLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchCapitalLedger.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(fetchCapitalAccountsBySearch.pending, (state) => {
        state.capitalAccountsLoading = true;
      })
      .addCase(fetchCapitalAccountsBySearch.fulfilled, (state, action) => {
        state.capitalAccountsLoading = false;
        state.capitalAccounts = action.payload;
      })
      .addCase(fetchCapitalAccountsBySearch.rejected, (state) => {
        state.capitalAccountsLoading = false;
        state.capitalAccounts = [];
      });
  },
});

export const { setFilters, resetCapitalLedger } = capitalLedgerSlice.actions;
export default capitalLedgerSlice.reducer;
